<template>
  <div class="company-switch">
    <v-select
        v-if="selectableCompanies.length > 1"
        :items="selectableCompanies"
        :label="$t('company.singular')"
        item-text="name"
        item-value="id"
        @change="changeCompany"
        :value="company"
        dense
        hide-details="auto"
        class="company-switch"
    />
    <span
        v-if="selectableCompanies.length === 1"
        class="only-company-name">{{company.name}}</span>
  </div>
</template>
<script>

import UserSessionStateService from '@/services/UserSessionStateService';

export default {
  name: 'company-switch',
  computed:{
    selectableCompanies() {return this.$store.getters['userSessionStateStore/selectableCompanies'];},
    company() {return this.$store.getters['userSessionStateStore/company'];},

  },
  methods: {
    changeCompany(companyId){
      UserSessionStateService.changeCompany(companyId).then(() =>{
        //reloading frontpage to make sure there is no remnants of state belongin to previously selected company
        window.location.href = this.$router.resolve('/status').href;
      });
    },
  },
};
</script>
